@if (
  {
    rowUserId: modalInteractionService.selectedUserId,
    qualificationNames: qualificationNames$ | async,
    qualificationFulfilled: qualificationFulfilled$ | async,
    workingTimeValidations: workingTimeValidations$ | async,
    shiftLogicValidations: shiftLogicValidations$ | async,
    professionValidations: professionValidations$ | async,
    tags: tags$ | async,
    overtimeVisible: overtimeVisible$ | async,
    showRadioButton: showRadioButton$ | async,
    hasFinishedLoadingScores: hasFinishedLoadingScores$ | async,
    isEnabledProfitabilityScores: isEnabledProfitabilityScores$ | async,
  };
  as data
) {
  <div>
    <div class="row item m-0">
      <div
        [ngClass]="data.overtimeVisible ? 'col-6' : 'col-10'"
        class="score-indicator"
      >
        <nz-radio-group
          [nzName]="'userId'"
          [ngModel]="data.rowUserId"
          (ngModelChange)="
            modalInteractionService.setSelectedUserIdAndRowIndex(
              user.id!,
              index
            )
          "
        >
          @if (data.showRadioButton) {
            <div nz-radio [nzValue]="user.id" class="radio">
              <ng-container [ngTemplateOutlet]="userInfo"></ng-container>
            </div>
          } @else {
            <div class="radio-content-row w-100 d-flex min-w-0">
              <div class="flex-shrink-0">
                <ng-container
                  *ngTemplateOutlet="
                    userInformation;
                    context: { displayUserAvatar: true }
                  "
                ></ng-container>
              </div>
              <div class="user-info flex-grow-1 min-w-0">
                <ng-container
                  *ngTemplateOutlet="
                    userInformation;
                    context: { displayUserAvatar: false }
                  "
                ></ng-container>
                <wilson-user-timeline-info-scores
                  [userTimeline]="user"
                  [prefScores]="prefScores$ | async"
                  [smartScores]="smartScores$ | async"
                  [hasFinishedLoadingScores]="data.hasFinishedLoadingScores"
                  [size]="data.overtimeVisible ? 'small' : 'large'"
                ></wilson-user-timeline-info-scores>
              </div>
            </div>
          }
          <ng-template #userInfo>
            <div class="radio-content-row w-100 d-flex min-w-0">
              <div class="flex-shrink-0">
                <ng-container
                  *ngTemplateOutlet="
                    userInformation;
                    context: { displayUserAvatar: true }
                  "
                ></ng-container>
              </div>
              <div class="user-info flex-grow-1 min-w-0">
                <ng-container
                  *ngTemplateOutlet="
                    userInformation;
                    context: { displayUserAvatar: false }
                  "
                ></ng-container>
                <wilson-user-timeline-info-scores
                  [userTimeline]="user"
                  [prefScores]="prefScores$ | async"
                  [smartScores]="smartScores$ | async"
                  [hasFinishedLoadingScores]="data.hasFinishedLoadingScores"
                  [size]="data.overtimeVisible ? 'small' : 'large'"
                ></wilson-user-timeline-info-scores>
              </div>
            </div>
          </ng-template>
        </nz-radio-group>
      </div>
      @if (
        ('portal-profitability-score-setting' | featureFlagPure | async) &&
          data.isEnabledProfitabilityScores &&
          (shiftProfitabilityScore$ | async);
        as shiftProfitabilityScore
      ) {
        <div class="col-2">
          <wilson-user-timelines-profitability-score
            [profitabilityScore]="shiftProfitabilityScore"
          >
          </wilson-user-timelines-profitability-score>
        </div>
      }
      @if (data.overtimeVisible) {
        <div class="col-2 overtime">
          @if (isLoadingUsersOvertimes$ | async) {
            <nz-skeleton [nzActive]="true"></nz-skeleton>
          }
          @if ((isLoadingUsersOvertimes$ | async) === false) {
            <wilson-overtime-value [overtimeInMinutes]="userOvertime$ | async">
            </wilson-overtime-value>
          }
        </div>
      }
      <div class="col-1">
        <wilson-user-timeline-info-qualifications
          [qualificationNames]="data.qualificationNames"
          [qualificationFulfilled]="data.qualificationFulfilled"
          [workingTimeValidations]="data.workingTimeValidations"
          [shiftLogicValidations]="data.shiftLogicValidations"
          [professionValidations]="data.professionValidations"
          [user]="user"
          [hasFinishedLoadingScores]="data.hasFinishedLoadingScores"
        ></wilson-user-timeline-info-qualifications>
      </div>
      <ng-template #userInformation let-displayUserAvatar="displayUserAvatar">
        <div
          #tooltip="nzTooltip"
          [nzTooltipOverlayStyle]="{
            'max-width': '600px',
            'min-width': '250px',
          }"
          [nzTooltipArrowPointAtCenter]="true"
          nz-tooltip
          [nzTooltipTitle]="userDetails"
          [nzTooltipColor]="'#fff'"
          nzTooltipPlacement="right"
        >
          @if (displayUserAvatar) {
            <wilson-user-avatar
              [s3Urn]="user.profileImageUrl || ''"
              class="me-1 avatar"
            ></wilson-user-avatar>
          } @else {
            <div class="user-name">
              {{ user.lastName + ', ' + user.firstName }}
            </div>
          }
        </div>
      </ng-template>
      <ng-template #userDetails>
        <wilson-shift-validations-tooltip
          (expanded)="onTooltipExpanded()"
          [qualificationNames]="data.qualificationNames"
          [workingTimeValidations]="data.workingTimeValidations"
          [shiftLogicValidations]="data.shiftLogicValidations"
        >
          <wilson-user-details [user]="user"></wilson-user-details>
        </wilson-shift-validations-tooltip>
      </ng-template>
    </div>
    <wilson-user-timeline-tags [tags]="data.tags"></wilson-user-timeline-tags>
  </div>
}
